import { useState, useEffect } from 'react';
import { AllScenarioWeights, BankRankings, DriverScores, ScenarioScores } from '../apiTypes';
import { createOrUpdateReportFile, fetchDriverScoresById, fetchFileLatestById, fetchFinalRankingById, fetchScenarioScoresById, fetchScenarioWeightsById } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';


export function useDriverScores(reportId?: string) {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [driverScores, setDriverScores] = useState<DriverScores | undefined>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId) return;

    const loadReport = async () => {
      setLoading(true);
      try {
        const data = await fetchDriverScoresById(reportId);
        setDriverScores(data);
        setError(null);
      } catch (err) {
        setError('Errore caricamento report');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, [reportId]);

  return { driverScores, loading, error };
}

export function useScenarioScores(reportId?: string) {
    useAxiosInterceptor(); //
    const [scenarioScores, setScenarioScores] = useState<ScenarioScores | undefined>();
    const [loadingScenarioReport, seLoadingScenarioReport] = useState(false);
    const [errorScenarioReport, SetErrorScenarioReport] = useState<string | null>(null);
  
    useEffect(() => {
      if (!reportId) return;
  
      const loadReport = async () => {
        seLoadingScenarioReport(true);
        try {
          const data = await fetchScenarioScoresById(reportId);
          setScenarioScores(data);
          SetErrorScenarioReport(null);
        } catch (err) {
            SetErrorScenarioReport('Errore caricamento report');
          console.error(err);
        } finally {
            seLoadingScenarioReport(false);
        }
      };
  
      loadReport();
    }, [reportId]);
  
    return { scenarioScores, loadingScenarioReport, errorScenarioReport };
  }

export function useFinalRanking(reportId?: string) {
    useAxiosInterceptor(); //
    const [finalRanking, setFinalRanking] = useState<BankRankings | undefined>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
  
    useEffect(() => {
      if (!reportId) return;
  
      const loadReport = async () => {
        setLoading(true);
        try {
          const data = await fetchFinalRankingById(reportId);
          setFinalRanking(data);
          setError(null);
        } catch (err) {
          setError('Errore caricamento report');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
  
      loadReport();
    }, [reportId]);
  
    return { finalRanking, loading, error };
  }

  export function useScenarioWeights(reportId?: string) {
    useAxiosInterceptor();
    const [scenarioWeights, setScenarioWeights] = useState<AllScenarioWeights | undefined>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
  
    useEffect(() => {
      if (!reportId) return;
  
      const loadReport = async () => {
        setLoading(true);
        try {
          const data = await fetchScenarioWeightsById(reportId);
          setScenarioWeights(data);
          setError(null);
        } catch (err) {
          setError('Errore caricamento report');
          console.error(err);
        } finally {
          setLoading(false);
        }
      };
  
      loadReport();
    }, [reportId]);
  
    return { scenarioWeights, loading, error };
  }


  
export function useReportFilesLasted(reportId?: string) {
  useAxiosInterceptor();
  const [file, setFile] = useState<any | undefined>();
  const [fileLoading, setFileLoading] = useState(false);
  const [fileError, setFileError] = useState<string | null>(null);

  const loadReport = async () => {
    if (!reportId) return;
    setFileLoading(true);
    try {
      const data = await fetchFileLatestById(reportId);
      setFile(data);
      setFileError(null);
    } catch (err) {
      setFileError('Errore caricamento file');
      console.error(err);
    } finally {
      setFileLoading(false);
    }
  };

  useEffect(() => {
    loadReport();
  }, [reportId]);

  return { file, fileLoading, fileError, refetch: loadReport };
}


export function useReportFilesCreateOrUpdate(reportId?: string) {
  useAxiosInterceptor(); // <--- monta l'interceptor
  const [createdFile, setCreatedFile] = useState<any | undefined>();
  const [createFileLoading, setCreateFileLoading] = useState(false);
  const [createFileError, setCreateFileError] = useState<string | null>(null);

  useEffect(() => {
    if (!reportId) return;

    const loadReport = async () => {
      setCreateFileLoading(true);
      try {
        const data = await createOrUpdateReportFile(reportId);
        setCreatedFile(data);
        setCreateFileError(null);
      } catch (err) {
        setCreateFileError('Errore caricamento file');
        console.error(err);
      } finally {
        setCreateFileLoading(false);
      }
    };

    loadReport();
  }, [reportId]);

  return { createdFile, createFileLoading, createFileError };
}

